export default {
    en: {
        home_title   : "Home",
        login        : "Login",
        goToDashboard: "Go To Dashboard"
    },
    el: {
        home_title   : "Αρχική",
        login        : "Σύνδεση",
        goToDashboard: "Πίνακας Ελέγχου"
    }
};